import React, { useEffect, useState } from 'react'
import { H3, H4, Card } from '@blueprintjs/core'
import SequenceContext from './SequenceContext'
import ImagesContainer from './ImagesContainer'
import Interludes from "../../InterludesPanel";
import FadeIn from 'react-fade-in';
import DoYouWish from '../../../Creer/DoYouWish'


const CMContainer = ({
    editMode,
    number,
    createSequence,
    changeContext,
    sequence,
    changeResources,
    resources,
    attributes,
    handleChangeAttribute,
    handleChangeAttributeUnitValue,
    handleDeleteAttribute,
    loadingDelete,
    handleReplacesResources,
    sessionId,
    interludes,
    onChangeInterludes,
    displayContextCM,
    handleChangeSequencesResourcesCM
}) => {

    const [showFormula, setShowFormula] = useState()
    const [displayQuestion, setDisplayQuestion] = useState(true)
    const [step, setStep] = useState(0)
    const [addIntro, setAddIntro] = useState(false)

    useEffect(() => {
        if (number === 1) {
            setShowFormula(true)
        } else {
            if (editMode) {
                // setShowFormula(true)
                setStep(3)
            }
        }
        // eslint-disable-next-line
    }, [])


    let goNextStep = x => {
        if (x > step) {
            setStep(x)
        }
    }

    return (
        <Card className='margin-top-large margin-bottom-large'>
            {(((number !== 1) || (showFormula === false)) && displayQuestion) &&
                <FadeIn>
                    <H3 className='text-center margin-bottom-medium'>Do you wish to add another sequence?</H3>
                    <DoYouWish
                        handleAnswer={setShowFormula}
                        goNextStep={() => { console.log('test') }}
                        nextStep={1}
                        alreadyFilled={resources && resources.length > 0}
                        displayContextCM={displayContextCM}
                        editMode={editMode}
                        createSequence={createSequence}
                        displayQuestion={setDisplayQuestion}
                    />
                </FadeIn>
            }
            {showFormula &&
                <FadeIn>
                    <H3 className='text-center margin-bottom-medium'>Sequence number {number}</H3>
                    <hr className='margin-bottom-large' />
                    <H4 className='text-center'>Do you wish to add an image / video as an introduction of this sequence ?</H4>
                    <div>
                        <DoYouWish
                            handleAnswer={setAddIntro}
                            goNextStep={goNextStep}
                            nextStep={1}
                            editMode={editMode}
                            alreadyFilled={sequence && sequence.intro && sequence.intro.length}
                        />
                        {addIntro &&
                            <FadeIn>
                                <Interludes
                                    sessionId={sessionId}
                                    interludes={interludes}
                                    onChangeInterludes={onChangeInterludes}
                                    number={number}
                                />
                            </FadeIn>
                        }
                        {((step >= 1 && addIntro === false) || (sequence && sequence.intro && sequence.intro.length > 0)) &&
                            <FadeIn>
                                <hr className='margin-bottom-large margin-top-large' />
                                <H4 className='text-center'>Add images for your sequence number {number}</H4>
                                <ImagesContainer
                                    number={number}
                                    resources={resources}
                                    changeResources={handleChangeSequencesResourcesCM}
                                    attributes={attributes}
                                    handleChangeAttribute={handleChangeAttribute}
                                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                                    handleDeleteAttribute={handleDeleteAttribute}
                                    loadingDelete={loadingDelete}
                                    handleReplacesResources={handleReplacesResources}
                                    handleChangeSequencesResourcesCM={handleChangeSequencesResourcesCM}
                                />
                            </FadeIn>
                        }
                        {(resources && resources.length) ?
                            <FadeIn>
                                <hr className='margin-bottom-large margin-top-large' />
                                <SequenceContext
                                    number={number}
                                    changeContext={changeContext}
                                    context={(sequence && sequence.sequenceContext) ? sequence.sequenceContext : ''}
                                />
                            </FadeIn>
                            :
                            <></>
                        }
                    </div>
                </FadeIn>
            }
        </Card>
    )
}

export default CMContainer
